
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { LoaderSubitoService } from '../../../../../../shared/components/loader-subito/service/loader-subito.service';
import { PerfilUserService } from '../../../../service/perfil-user.service';
import { DevolucionDineroService } from '../../../../../devolucion-dinero/service/devolucion-dinero.service';
import { NotificationsService } from '../../../../../../shared/components/notifications/service/notifications.service';
import { AppState } from '../../../../../../store/app.state';
import { Store } from '@ngrx/store';
import { setBalance } from '../../../../store/balance.actions';

@Component({
  selector: 'solicitar-devolucion',
  imports: [],
  templateUrl: './solicitar-devolucion.component.html',
  styleUrl: './solicitar-devolucion.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolicitarDevolucionComponent {
  @Input() idOrden: number = 0;
  @Output() reload = new EventEmitter<boolean>();
  // Signals para el estado del modal
  private _isModalOpen = signal(false);
  private _selectedRefundMethod = signal<'subicoins' | 'card' | null>(null);

  constructor(
    private sppinerSubito: LoaderSubitoService,
    private perfilService: PerfilUserService,
    private devolucionDineroService: DevolucionDineroService,
    private notificationService: NotificationsService,
    private store: Store<AppState>
  ) { }

  // Getters para los signals (readonly)
  isModalOpen = this._isModalOpen.asReadonly();
  selectedRefundMethod = this._selectedRefundMethod.asReadonly();

  openModal(): void {
    this._isModalOpen.set(true);
    this._selectedRefundMethod.set(null); // Reset selection when opening
  }

  closeModal(): void {
    this._isModalOpen.set(false);
    this._selectedRefundMethod.set(null); // Reset selection when closing
  }

  selectRefundMethod(method: 'subicoins' | 'card'): void {
    this._selectedRefundMethod.set(method);
  }

  submitDevolucion(): void {
    const selectedMethod = this._selectedRefundMethod();
    if (!selectedMethod) {
      return;
    }

    // TODO: Implementar la lógica de envío de la solicitud de devolución
    // console.log('Solicitud de devolución:', {
    //   idOrden: this.idOrden,
    //   refundMethod: selectedMethod
    // });
    this.sppinerSubito.showLoader();
    this.devolucionDineroService.RefundType(
      this.idOrden,
      selectedMethod
    ).subscribe({
      next: (res) => {
        this.sppinerSubito.hideLoader();
        this.reload.emit(true);
        this.notificationService.addNotification({
          type: 'success',
          message: res.message
        });
        this.perfilService.getProfile().subscribe({
          next: (profile) => {
            this.store.dispatch(setBalance({ balance: profile.data.balance }))
            // console.log(profile);
          },
          error: (profileErr) => {
            console.error('Error al obtener perfil:', profileErr);
          }
        });
        // console.log(res);
        // Cerrar el modal después de completar todas las operaciones
        this.closeModal();
      },
      error: (err) => {
        this.sppinerSubito.hideLoader();
        // console.log(err);
        this.closeModal();
      }
    });
  }
}
